export default __webpack_public_path__ + "static/media/pexels-lukas-590022.a7fa05d1.jpg";